import { useNavigate } from "react-router-dom";

export default function SignUpComplete({ onBack }) {
    const nav = useNavigate();

    const handleSubmit = (e) => {
        e.preventDefault();
        nav("/login");
    };


    return (
        <form onSubmit={handleSubmit} className="flex flex-col w-full h-full flex-1">
            <div className="py-9">
                <p className="text-2xl md:text-3xl  leading-tight font-bold">
                    스마트 피트니스
                </p>
                <p className="text-2xl md:text-3xl  leading-tight">회원가입이 완료되었습니다.</p>
                <p className="text-sm md:text-lg text-[#4A8AFF] mt-2">
                    1:1 맞춤형 루틴 케어 서비스를 시작해보세요.
                </p>
            </div>
            <div className="mt-auto  py-6 space-y-3 " >
                <button
                    className="
                            w-full
                            bg-[#5F9BFF]         
                            hover:bg-[#4A8AFF]    
                            text-white
                            py-3
                            md:py-4 
                            rounded-xl
                            text-lg 
                            md:text-xl
                            "
                >시작하기</button>
                <button
                    className="
                            w-full
                            border-solid          
                            border-[1px]        
                            border-[#5F9BFF]
                            text-[#5F9BFF]
                            py-3 
                            md:py-4 
                            rounded-xl
                            text-lg 
                            md:text-xl
                        "
                >
                    메인 화면으로
                </button>

            </div>
        </form >
    );
}
